import { render, staticRenderFns } from "./ContactActionsEmails.vue?vue&type=template&id=5b9cd95c&scoped=true&"
var script = {}
import style0 from "./ContactActionsEmails.vue?vue&type=style&index=0&id=5b9cd95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9cd95c",
  null
  
)

export default component.exports